import { Vector3 } from 'three';
import { BaseDynamicArticlePostParseProcessor } from '@project/components/article/processor/postparse/base-dynamic-article-post-parse.processor';
import { ArticleContainerPropertyDef } from '@article/constants/article-container-property-def';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { Rectangle3D } from '@3d-scene/model/rectangle-3d';
import { MathUtils } from '@3d-scene/common/util/math-utils';

export class DynamicLabelingArticlePostParseProcessor extends BaseDynamicArticlePostParseProcessor {
  protected processOriginalDynamicConnections(container: ArticleContainer, originalConnectionNames: string[]): void {
    if (!container.properties.containsKey(ArticleContainerPropertyDef.TEXT_ANGLE)) {
      container.properties.setValue(ArticleContainerPropertyDef.TEXT_ANGLE, this.searchTextRotationAngle(container, originalConnectionNames));
    }
    super.processOriginalDynamicConnections(container, originalConnectionNames);
  }

  protected getPredefinedTextureConnectionsCount(articleContainer: ArticleContainer): number {
    const articlesGUIDsBetweenAdapters: string[] = articleContainer.properties.getValue(ArticleContainerPropertyDef.ARTICLES_GUIDS_BETWEEN_ADAPTERS);
    return articlesGUIDsBetweenAdapters ? articlesGUIDsBetweenAdapters.length : NaN;
  }

  private searchTextRotationAngle(container: ArticleContainer, connectionNames: string[]): number {
    let textRotationAngle: number = 0;
    for (const connectionName of connectionNames) {
      const connection: Connection = container.findFirstConnectionByName(connectionName);
      if (connection) {
        if (connection.type === Connection.TYPE_TEXT) {
          textRotationAngle = this.getAngleTextRotation(connection.compositionRectangle);
        }
      }
    }
    return textRotationAngle;
  }

  private getAngleTextRotation(rectangleText: Rectangle3D): number {
    const firstPoint: Vector3 = rectangleText.point1;
    const secondPoint: Vector3 = rectangleText.point4;
    const angle: number = MathUtils.getAngleWithNormal(
      new Vector3(-1, 0, 0),
      new Vector3(secondPoint.x - firstPoint.x, secondPoint.y - firstPoint.y, secondPoint.z - firstPoint.z),
      new Vector3(0, 1, 0)
    );
    return (angle * 180) / Math.PI;
  }
}
